import { FunctionalComponent, h } from "preact"
import { useState } from "preact/hooks";
import { CallToActionButton } from "../../../components/CallToActionButton";
import { CloseIcon } from "../../../icons/Close";
import { ModalContentStyled, ModalOverlayStyled, ModalStyled, RewardDetailStyled } from "./reward-offer-modal.style"

interface RewardOfferModalInterface {
  id: number;
  isActive: boolean;
  isDisabledSubmitButton: boolean;
  title: string;
  imageUrl: string;
  description: string;
  expirationDate: string;
  callbackOnSubmitButton: (item: any) => void;
  callbackOnCloseModal: () => void;
}

export const RewardOfferModal: FunctionalComponent<RewardOfferModalInterface> = ({
  id,
  isActive,
  isDisabledSubmitButton,
  title,
  imageUrl,
  description,
  expirationDate,
  callbackOnSubmitButton,
  callbackOnCloseModal
}) => {
  const closeModal = (e: any) => {
    callbackOnCloseModal();
  };

  const useWithOrder = (e: any) => {
    callbackOnSubmitButton({ id: id });
  };

  return (
    <div>
      {isActive && (
        <ModalStyled className={(isActive ? 'revealing' : 'revealing out')}>
          <ModalContentStyled className="modal-content">

            <RewardDetailStyled>
              <span class="modal-close-button" onClick={closeModal}><CloseIcon></CloseIcon></span>
              <img src={imageUrl} />
              <div>
                <span class="title" dangerouslySetInnerHTML={{
                  __html: title
                }}></span>
                {expirationDate && (
                  <span class="subtitle">EXPIRES {expirationDate}</span>
                )}

                <p class="description" dangerouslySetInnerHTML={{
                  __html: description
                }}></p>

                <CallToActionButton onClick={useWithOrder} disabled={isDisabledSubmitButton}>
                  Use with Order
                </CallToActionButton>

                <a class="link-button" onClick={closeModal}>Use another time</a>
              </div>
            </RewardDetailStyled>

          </ModalContentStyled>
          <ModalOverlayStyled className="modal-overlay"></ModalOverlayStyled>
        </ModalStyled>
      )}
    </div>
  )
}